// Utility function to get the correct image URL
export const getImageUrl = (imagePath) => {
  if (!imagePath) return '';
  
  // If the image path is already a full URL (Cloudinary), return it as is
  if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
    return imagePath;
  }

  // Clean Windows backslashes and remove 'uploads/' prefix if present
  let cleanPath = imagePath.replace(/\\/g, '/');
  if (cleanPath.startsWith('uploads/')) {
    cleanPath = cleanPath.substring(8);
  }
  
  // Fallback for local images (if any)
  if (process.env.NODE_ENV === 'development') {
    return `/uploads/${cleanPath}`;
  }
  
  const serverUrl = process.env.REACT_APP_SERVER_URL || 'http://localhost:5000';
  return `${serverUrl}/uploads/${cleanPath}`;
};

// Alternative: Always use the full server URL or return Cloudinary URL as is
export const getImageUrlFull = (imagePath) => {
  if (!imagePath) return '';
  
  // Debug logging
  console.log('getImageUrlFull called with:', imagePath);
  
  // If the image path is already a full URL (Cloudinary), return it as is
  if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
    console.log('Returning Cloudinary URL:', imagePath);
    return imagePath;
  }

  // Clean Windows backslashes and remove 'uploads/' prefix if present
  let cleanPath = imagePath.replace(/\\/g, '/');
  if (cleanPath.startsWith('uploads/')) {
    cleanPath = cleanPath.substring(8);
  }
  
  // For development, use the proxy (same as getImageUrl)
  if (process.env.NODE_ENV === 'development') {
    const url = `/uploads/${cleanPath}`;
    console.log('Returning development URL:', url);
    return url;
  }
  
  // For production, construct full URL
  const protocol = window.location.protocol;
  const hostname = window.location.hostname;
  const port = '';
  const url = `${protocol}//${hostname}${port}/uploads/${cleanPath}`;
  console.log('Returning production URL:', url);
  return url;
}; 